import React from "react";

import AboutPageV1 from "../../component/pages/AboutPage";
import AboutPageV2 from "../../V2/components/pages/AboutPage";

function About() {
  const isV2 = process.env.NEXT_PUBLIC_REACT_APP_SKIN === 'taxnumber';

  if (isV2) {
    return (
      <AboutPageV2 />
    )
  }

  return (
    <AboutPageV1 />
  );
}

export default About;
